import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form/immutable';
import Button from '@material-ui/core/Button';
import ReduxDialog from '../../Common/ReduxDialog/index';
import { hideDialog } from '../../../redux/actions/dialogs';
import { toJS } from '../../../utils/helper';

import styles from './styles';

import { FIND_JOB_DIALOG } from '../../../redux/constants/dialogs';
import JobsGrid from './JobsGrid/index';
import { fetchCustomersRoutine, fetchJobsRoutine } from '../../../redux/routines';
import { getDialogContextValue } from '../../../redux/selectors';

class FindJob extends Component {
  static propTypes = {
    fetchJobs: PropTypes.func.isRequired,
    fetchCustomers: PropTypes.func.isRequired,

    jobs: PropTypes.object,
    customers: PropTypes.object,

    onRequestClose: PropTypes.func,
    hideDialog: PropTypes.func.isRequired,
    onSelect: PropTypes.func,
  };

  componentWillMount() {
    this.props.fetchJobs();
    this.props.fetchCustomers();
  }

  handleSelect = (job) => {
    console.log('handleSelect', job);
    this.props.onSelect(job);
    this.props.hideDialog(FIND_JOB_DIALOG);
  };

  render() {
    const { jobs, fetchJobs } = this.props;

    const actions = [
      <Button
        key="cancel"
        variant="text"
        onClick={() => this.props.hideDialog(FIND_JOB_DIALOG)}
      >Cancel</Button>,
    ];

    return (
      <ReduxDialog
        name={FIND_JOB_DIALOG}
        title="Find Job"
        actions={actions}
        onRequestClose={() => this.props.hideDialog(FIND_JOB_DIALOG)}
        bodyStyle={styles.body}
        fullWidth
        maxWidth="md"
      >
        {/*<form name="findJob" onSubmit={handleSubmit}>*/}
        {/*<div style={styles.tabPage}>*/}
        {/*<div style={commonStyles.row}>*/}
        {/*<AutoComplete*/}
        {/*name="customerId"*/}
        {/*style={commonStyles.input}*/}
        {/*label="Customer"*/}
        {/*InputLabelProps={{shrink: true}}*/}
        {/*openOnFocus*/}
        {/*filter={customizedFuzzyFilter}*/}
        {/*dataSource={customers}*/}
        {/*dataSourceConfig={customerDSConfig}*/}
        {/*onNewRequest={this.handleSelectCustomer}*/}
        {/*fullWidth/>*/}
        {/*</div>*/}
        {/*</div>*/}
        {/*</form>*/}
        <JobsGrid
          data={jobs}
          fetch={fetchJobs}
          onSelect={this.handleSelect}
        />
      </ReduxDialog>
    );
  }
}

const form = reduxForm({
  form: FIND_JOB_DIALOG,  // a unique identifier for this form
})(FindJob);

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchJobs: fetchJobsRoutine.trigger,
    fetchCustomers: fetchCustomersRoutine.trigger,
    hideDialog,
  }, dispatch);
}

function mapStateToProps(state) {
  const jobs = toJS(state.getIn(['jobs', 'jobs']), []); //.sort((a, b) => sortDates(a.start, b.start));
  const customers = toJS(state.getIn(['customers', 'customers']));

  return {
    jobs,
    customers,
    onSelect: getDialogContextValue(state)(FIND_JOB_DIALOG, 'onSelect'),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Jobs/FindJobDialog/index.js